import React from "react";
import Crad from "./Crad";
import styles from "./Plans.module.scss";
import Tabs from "./RewardsTabs";

const Plans = () => {
  return (
    <section className={styles.plans}>
      <div className={styles.blobBottom} />
      <div className={styles.container}>
        <h1 className={styles.title}>
          Initial Token <span className={styles.titleSpan}>Offering (ITO)</span>
        </h1>
        <div className={styles.allCards}>
          <Crad
            phase={"Phase 1"}
            price={"$0.0125"}
            Percentage={"50%"}
            tokens={"2,592,000,000 tokens"}
            image={"/assets/Image/coins1.png"}
          />
          <Crad
            phase={"Phase 2"}
            price={"$0.03"}
            Percentage={"30%"}
            tokens={"1,555,200,000 tokens"}
            image={"/assets/Image/coin2.png"}
          />
          <Crad
            phase={"Phase 3"}
            price={"$0.06"}
            Percentage={"20%"}
            tokens={"1,036,800,000 tokens"}
            image={"/assets/Image/coin3.png"}
          />
        </div>

        <div className={styles.rewardsTbas}>
          <Tabs />
        </div>
      </div>
    </section>
  );
};

export default Plans;
